import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { EquipmentFilter, ListItem, RepositoryModal } from '../../shared'
import { EquipmentFilterListComponent } from './equipment-filter-list.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    templateUrl: './equipment-filter-modal.component.html',
    standalone: true,
    imports: [FormsModule, FaIconComponent, WjInputModule],
})
export class EquipmentFilterModalComponent extends RepositoryModal<EquipmentFilter> {
    equipmentOptions: ListItem<string>[] = []

    protected onInitialized() {
        this.equipmentOptions = (this.editOptions.initializeParams as EquipmentFilterListComponent).equipmentOptions
    }

    protected onSave(resolveSave: (result?: any) => void, rejectSave: (reason?: any) => void) {
        super.onSave(
            result => {
                ;(this.editOptions.initializeParams as EquipmentFilterListComponent).parent.refresh()
                resolveSave(result)
            },
            rejectSave,
        )
    }
}
